import { useButton } from '@react-aria/button';
import { useDialog } from '@react-aria/dialog';
import { FocusScope } from '@react-aria/focus';
import { useOverlay } from '@react-aria/overlays';
import I18n from 'I18n';
import { useRef } from 'react';
import styled from 'styled-components';
import SVGClose from 'visitor-ui-component-library-icons/icons/SVGClose';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_OVERLAY_COLOR = 'rgba(197, 213, 230, 0.5)'; // #CBD6E2, 50% opacity
const DEFAULT_BACKGROUND_COLOR = '#ffffff';
const UPDATED_VISITOR_WIDGET_BORDER_RADIUS = 10;
const ModalWrapper = styled.div.withConfig({
  displayName: "WidgetModal__ModalWrapper",
  componentId: "t101nh-0"
})(["position:absolute;top:0;left:0;width:100%;height:100%;background-color:", ";display:flex;align-items:end;z-index:1000;border-radius:", "px;"], ({
  $overlayColor
}) => $overlayColor, UPDATED_VISITOR_WIDGET_BORDER_RADIUS);
const ModalBody = styled.div.withConfig({
  displayName: "WidgetModal__ModalBody",
  componentId: "t101nh-1"
})(["background-color:", ";border-radius:8px;max-width:100%;width:100%;max-height:50%;overflow:auto;"], ({
  $backgroundColor
}) => $backgroundColor);
const ModalHeader = styled.div.withConfig({
  displayName: "WidgetModal__ModalHeader",
  componentId: "t101nh-2"
})(["display:flex;justify-content:space-between;background-color:", ";"], ({
  $backgroundColor
}) => $backgroundColor);
const CloseButton = styled(VizExIconButton).withConfig({
  displayName: "WidgetModal__CloseButton",
  componentId: "t101nh-3"
})(["flex:0;font-size:16px;padding:24px 16px;background-color:", ";"], ({
  $backgroundColor
}) => $backgroundColor);
const ModalContent = styled.div.withConfig({
  displayName: "WidgetModal__ModalContent",
  componentId: "t101nh-4"
})(["background-color:", ";"], ({
  $backgroundColor
}) => $backgroundColor);
const WidgetModal = ({
  isOpen,
  onClose,
  modalContent
}) => {
  const ref = useRef(null);
  const {
    overlayProps,
    underlayProps
  } = useOverlay({
    isOpen,
    onClose,
    shouldCloseOnBlur: false
  }, ref);
  const {
    dialogProps
  } = useDialog({
    id: 'live-chat-widget-modal'
  }, ref);
  const {
    buttonProps
  } = useButton({
    onPress: onClose
  }, useRef(null));
  const {
    colorOverrides
  } = modalContent || {};
  if (!isOpen || !modalContent) {
    return null;
  }
  return /*#__PURE__*/_jsx(ModalWrapper, Object.assign({}, underlayProps, {
    $overlayColor: (colorOverrides === null || colorOverrides === void 0 ? void 0 : colorOverrides.overlayColor) || DEFAULT_OVERLAY_COLOR,
    children: /*#__PURE__*/_jsx(FocusScope, {
      contain: true,
      autoFocus: true,
      children: /*#__PURE__*/_jsxs(ModalBody, Object.assign({}, overlayProps, dialogProps, {
        ref: ref,
        $backgroundColor: DEFAULT_BACKGROUND_COLOR,
        children: [/*#__PURE__*/_jsxs(ModalHeader, {
          $backgroundColor: (colorOverrides === null || colorOverrides === void 0 ? void 0 : colorOverrides.headerBackgroundColor) || DEFAULT_BACKGROUND_COLOR,
          children: [modalContent.headerContent ? modalContent.headerContent : null, /*#__PURE__*/_jsx(CloseButton, Object.assign({}, buttonProps, {
            "data-test-id": "modal-close-button",
            onClick: onClose,
            use: "primary-transparent-background",
            "aria-label": I18n.text('conversations-visitor-experience-components.widgetModal.close'),
            $backgroundColor: (colorOverrides === null || colorOverrides === void 0 ? void 0 : colorOverrides.headerBackgroundColor) || DEFAULT_BACKGROUND_COLOR,
            children: /*#__PURE__*/_jsx(VizExIcon, {
              icon: /*#__PURE__*/_jsx(SVGClose, {})
            })
          }))]
        }), /*#__PURE__*/_jsx(ModalContent, {
          $backgroundColor: (colorOverrides === null || colorOverrides === void 0 ? void 0 : colorOverrides.contentBackgroundColor) || DEFAULT_BACKGROUND_COLOR,
          children: modalContent.bodyContent ? modalContent.bodyContent : null
        })]
      }))
    })
  }));
};
WidgetModal.displayName = 'WidgetModal';
export default WidgetModal;